import { createContext, useContext } from 'react'


export const MediaContext = createContext(null)

const useMedia = () => useContext(MediaContext)


export default useMedia
